<template>
    <div class="pb0 pl0">
        <transition name="fade">
            <div v-if="error" class="notifix notifix-error">
                <i class="fa fa-times" style="position: absolute;top: 1rem;right: 1rem; cursor:pointer;" aria-label="close" @click="error=null"></i>

                <p>{{error}}</p>
            </div>
        </transition>

        <div class="field has-addons" style="position: relative;">
            <div id="barcontrol" class="control is-expanded has-icons-right">
                <i class="fa fa-close f-modal-close is-hidden-mobile" style="z-index: 6;margin-top: -0.5rem;"
                   @click="needle=null;selected=null;">
                </i>

                <input :class="{'inputShouldAppear': shouldAppear}" type="search" id="servicesbar" class="input" v-model="needle" @focus="setDdWidth()" placeholder="Escreva aqui o que procura">
            </div>

            <!--Search button-->
            <div class="control">
                <a class="button is-primary"
                   @click="selected ? setParentService(selected) : promptSelection()"
                >Pedir propostas&nbsp;
                    <i class="fa fa-angle-right"></i>
                </a>
            </div>


            <!--Result list-->
            <div v-if="shouldAppear" id="results" :style="'min-width:'+(w-3)+'px;max-width:'+(w-3)+'px'">
                <p
                        :style="'min-width:'+(w-3)+'px;max-width:'+(w-3)+'px'"
                        class="result"
                        v-if="matches.length >= n"
                        v-for="n in 5"
                        @click="selectFromDropDown(matches[n-1])"


                >{{matches[n-1].title}}
                    <i class="fa fa-2x fa-angle-right has-text-primary is-pulled-right ddcaret"></i>
                </p>
                <p v-if="fill <= 0 && matches.length !== 0" :style="'min-width:'+(w-3)+'px;max-width:'+(w-3)+'px'" @click="moreModal = true" class="result more">Mostrar mais
                    <i class="fa fa-2x fa-angle-right has-text-primary is-pulled-right ddcaret"></i>
                </p>

                <p v-if="matches.length === 0" :style="'min-width:'+(w-3)+'px;max-width:'+(w-3)+'px'" class="result zero">Nenhum resultado encontrado
                </p>
            </div>
        </div>



        <!--Modal-->
        <transition name="fade">

            <div class="modal" :class="{'is-active': moreModal}">
                <div class="modal-background"></div>

                <div class="modal-card">
                    <header class="modal-head">
                        <p><img src="/static/images/layout/logotop.png" alt="Facilimo" style="width:12rem;"></p>
                        <p class="modalsub" style="margin:1rem 0 0;">Está interessado em que tipo de serviço?</p>

                        <i class="fa fa-close f-modal-close" @click="closeModal"></i>
                    </header>

                    <section class="modal-card-body" style="padding:0.5rem 0;">

                        <div id="list" class="modal-list">

                            <p @click="checked=index; selected=line" class="result mod-result" v-for="line, index in matches">{{line.title}}
                                <i v-if="checked == index" class="fa fa-lg fa-fw fa-check-square" style="color:#E90054; line-height: 3rem;"></i>
                                <i v-else class="fa fa-lg fa-fw fa-square-o" style="color:#E90054; line-height: 3rem;" ></i>
                            </p>

                        </div>

                    </section>


                    <!--Modal button-->
                    <footer class="">
                        <a class="button button-foot is-primary is-fullwidth" @click="checked ? setParentService(selected) : null">
                            Continuar
                        </a>
                    </footer>

                </div>





            </div>

        </transition>


    </div>



</template>

<script>
import { notificationMixin } from "../plugins/notificationMixin";

export default {
  mixins: [notificationMixin],
  props: ["services"],

  data() {
    return {
      checked: null,
      moreModal: false,
      w: 100,
      fill: 0,
      needle: null,
      selected: null
    };
  },

  computed: {
    shouldAppear() {
      return (
        !!this.needle &&
        this.needle.length > 0 &&
        !this.selected &&
        !this.moreModal
      );
    },

    matches() {
      if (this.needle) {
        let matchesAry = [];
        for (let i = 0; i < this.services.length; i++) {
          if (
            this.services[i].title
              .trim()
              .toLowerCase()
              .indexOf(this.needle.toLowerCase()) !== -1
          ) {
            matchesAry.push(this.services[i]);
          }
        }
        if (matchesAry && matchesAry.length > 0) {
          this.fill = 5 - matchesAry.length;
        }
        return matchesAry;
      }
    }
  },

  watch: {
    needle: function(newVal, oldVal) {
      if (this.service) {
        if (newVal.trim().length !== this.service.title.trim().length) {
          this.reset();
        }
      }
    }
  },

  mounted() {
    this.setDdWidth();
  },

  methods: {
    setDdWidth() {
      this.w = Math.max(document.getElementById("barcontrol").offsetWidth, 240);
    },

    setParentService(data) {
      this.$emit("openOrderModal");
      this.$emit("setParentService", data);
      this.reset();
    },

    closeModal() {
      this.moreModal = false;
      this.checked = null;
      this.needle = null;
    },

    reset() {
      this.closeModal();
      this.selected = null;
    },
    selectFromDropDown(item) {
      let o = {};
      Object.assign(o, item);
      this.needle = o.title.trim();
      this.selected = o;
    },
    promptSelection() {
      this.error = "Por favor, seleccione uma das opções disponíveis na lista.";
    }
  }
};
</script>
<style scoped lang="scss">
$input-height: 4rem;
$info: #2d3256;
$primary: #e90054;

.inputShouldAppear {
  border-bottom-left-radius: 0 !important;
}

.modal {
  border-radius: 5px;
}
.modalsub {
  color: $info;
  font-size: 1.25rem;
  font-weight: 700;
}
.modal-head {
  background-color: #f5f5f5;
  text-align: center;
  padding: 1.5rem;
}
.modal-card {
  border-radius: 5px;
}

.modal-content {
  padding: 1.5rem 0;
  background-color: white;
  text-align: center;
}

.f-modal-close {
  color: #dedede;
  position: absolute;
  font-size: 2rem;
  top: 1.5rem;
  right: 1.5rem;
  cursor: pointer;
}

.modal-list {
  padding: 0;
  text-align: left;
  max-height: 45vh;
  overflow-y: scroll;
  background-color: white;
}

.input {
  font-size: 1.25rem;
  height: $input-height;
  border-radius: 5px 0 0 5px;
}

.button {
  font-size: 1.5rem;
  padding: 1rem 2rem;
  height: 4rem;
  border-radius: 0 5px 5px 0;
}

.button-foot {
  border-radius: 0;
}

.modal-button {
  border: none;
}

.mod-result {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 3rem;
  border-bottom: solid 1px #f5f5f5;
  cursor: pointer;
}

#results {
  top: $input-height;
  position: absolute;

  background-color: white;
  z-index: 4;

  -moz-box-shadow: 6px 10px 6px 1px rgba(50, 50, 50, 0.4);
  -webkit-box-shadow: 6px 10px 6px 1px rgba(50, 50, 50, 0.4);
  box-shadow: 6px 10px 6px 1px rgba(50, 50, 50, 0.4);
}

.result {
  line-height: $input-height * 0.8;
  padding: 0 1.5rem;
  z-index: 5;
  cursor: pointer;
}

.result:hover {
  background-color: $info;
  color: white;
}

.ddcaret {
  padding-top: 0.8rem;
}

.more {
  color: $primary;
}
.more:hover {
  color: white;
}

.zero {
  color: #969696;
  font-style: italic;
  cursor: default;
}
.zero:hover {
  background-color: white;
  color: #969696;
}

@media screen and (max-width: 769px) {
  .button {
    font-size: 0.75rem;
    padding: 1rem 0.25rem;
  }
  .input {
    font-size: 0.75rem;
  }
  .result {
    line-height: 4rem;
    font-size: 0.75rem;
    padding: 0 1.5rem;
    z-index: 5;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SearchDropDown.vue